import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#eui-icon" }),
    /*#__PURE__*/_createTextVNode(" Icon ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Element Plus provides a set of common icons. ")
], -1)
const _hoisted_2 = { class: "mb-10" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#basic-usage" }),
  /*#__PURE__*/_createTextVNode(" Basic usage ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Just assign the class name to "),
  /*#__PURE__*/_createVNode("code", null, "el-icon-iconName"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "el-icon-edit demo-icon" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "el-icon-share demo-icon" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "el-icon-delete demo-icon" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Search")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createVNode(_component_el_button, {
          type: "primary",
          icon: "el-icon-search"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_CodeHighlighter, { lang: "html" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.code), 1)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}